/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { get } from 'lodash';

import adminApi from '../../services/admin-api';
import Filter from '../../components/Filters/Filter';

import './Modal.css';

const AdminAccessModal = ({ isOpen, onClose, users, updateList }) => {
  const [errorMessage, setErrorMessage] = useState(false);
  const [userToGrant, setUserToGrant] = useState(null);
  const [userOpts, setUserOpts] = useState([]);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(false);

  const onCloseModal = () => {
    onClose();
  };

  const userIsAdmin = u => {
    const roles = get(u, 'roles', []);

    return roles.includes('admin') || roles.includes('admin-read');
  };

  const grantAccess = async () => {
    if (!userToGrant) {
      setErrorMessage('Select a user!');
    }
    setLoading(true);
    const result = await adminApi.grantAdminAccess(
      userToGrant.value,
      role.value
    );

    setLoading(false);
    if (!result) {
      setErrorMessage('Something went wrong. Try again or contact a developer');
      return false;
    }

    setRole(null);
    setUserToGrant(null);
    setErrorMessage(false);
    updateList();
  };

  const revokeAccess = u => async () => {
    setLoading(true);
    const result = await adminApi.revokeAdminAccess(u);
    setLoading(false);
    if (!result) {
      setErrorMessage('Something went wrong. Try again or contact a developer');
      return false;
    }
    setErrorMessage(false);
    updateList();
  };

  const handleDropdownChange = (id, v) => {
    if (id === 'cvmi-admin__role') {
      setRole(v);
    } else if (id === 'cvmi-admin__user') {
      setUserToGrant(v);
    }
  };

  useEffect(() => {
    setUserOpts(users.map(u => ({ label: u.email, value: u })));
  }, [users]);

  useEffect(() => {
    return () => {
      setLoading(false);
      setRole(null);
      setUserToGrant(null);
      setErrorMessage(false);
    };
  }, []);

  return (
    <Modal
      className="cvmi-admin__edit-user-modal"
      id="cvmi-admin__edit-user-modal"
      show={isOpen}
      onHide={onCloseModal}
      backdrop
    >
      <div className="cvmi-admin__edit-user-modal-row">
        <h1 className="cvmi-admin__h1">Admin Users</h1>
      </div>

      <div>
        {users
          .filter(u => userIsAdmin(u))
          .map(u => (
            <div key={`admin-${u.uuid}`}>
              <div className="cvmi-admin__admin-user-list-row">
                <div className="cvmi-admin__revoke-admin-access-email">
                  {u.email}
                </div>
                <div className="cvmi-admin__revoke-admin-access-role">
                  {u.roles[0]}
                </div>
                <button
                  className="cvmi-admin__revoke-admin-access-button"
                  onClick={revokeAccess(u)}
                  disabled={loading}
                >
                  revoke
                </button>
              </div>
            </div>
          ))}
      </div>

      <div className="cvmi-admin__edit-user-modal-row">
        <h2 className="cvmi-admin__h2">Grant Admin Access</h2>
      </div>

      <div className="cvmi-admin__grant-access-form-row">
        <span className="cvmi-admin__grant-access-form-row-label">User:</span>
        <Filter
          className="cvmi-admin__grant-admin-dropdown"
          onChange={handleDropdownChange}
          showInlineSelections
          id="cvmi-admin__user"
          options={userOpts}
          value={userToGrant}
        />
      </div>

      <div className="cvmi-admin__grant-access-form-row">
        <span className="cvmi-admin__grant-access-form-row-label">Role:</span>
        <Filter
          className="cvmi-admin__grant-admin-dropdown"
          onChange={handleDropdownChange}
          showInlineSelections
          id="cvmi-admin__role"
          options={[
            { value: 'READWRITE', label: 'Admin READWRITE' },
            { value: 'READ', label: 'Admin READ' }
          ]}
          value={role}
        />
      </div>

      {errorMessage !== false ? (
        <div className="cvmi-admin__downtime-error-text">
          Wuh-Woh. Something went wrong: {errorMessage}
        </div>
      ) : null}
      <div className="cvmi-admin__grant-admin-submit-wrapper">
        <button
          className="tvt-admin__button create"
          onClick={grantAccess}
          disabled={!userToGrant || loading}
        >
          Submit
        </button>
      </div>
    </Modal>
  );
};

export default AdminAccessModal;
